module.exports = __webpack_public_path__ + "media/icons/desktop-0d58556f.png";